import React from 'react'
import Boron from 'boron'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class VerifyAlert extends React.Component {
  static propTypes = {
    onClick: PropTypes.func
  }

  toggleDialog(ref) {
    return this.refs[ref].toggle()
  }

  onClick() {
    this.props.onClick()
    this.toggleDialog('OutlineModal')
  }

  getContent(modalName) {
    return (
      <div className={styles.container}>
        <div className="row center-sm">
          <div className="col-xs-12 col-sm-12">
            <div className={styles.logo}>
              <img src="/email.png" alt="email" />
            </div>
          </div>
        </div>
        <h4 className={styles.title}>
          Para firmar o enviar un documento debes <b>verificar tu email</b>.
        </h4>
        <div className="row center-sm">
          <div className="col-xs-12 col-sm-12">
            <button className={styles.btn} onClick={() => this.onClick()}>
              <b>VERIFICAR EMAIL</b>
            </button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const Modal = Boron['OutlineModal']
    return (
      <div className={styles.container}>
        <Modal ref={'OutlineModal'}>{this.getContent('OutlineModal')}</Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/VerifyAlert/index.js